import { connect } from 'react-redux';

import Contribute from 'components/Contribute';
import * as actions from 'actions';
import { getForumContributeSubject, getForumTextEditing, getForumEmojis, getInfoState } from 'selectors';

const mapStateToProps = (state, props) => {
  const contributeSubject = getForumContributeSubject(state);
  const forumContributeTextEditing = getForumTextEditing(state, 'forumContribute');
  const isSubmitDisabled = forumContributeTextEditing.isSubmitting || !contributeSubject.subject.length || !forumContributeTextEditing.text.length;
  const successState = getInfoState(state, 'success');
  const isSuccessInfoBarVisible = successState.visible;
  const successInfoBarMessage = successState.message;
  const successInfoBarTitle = successState.title;

  return {
    ...forumContributeTextEditing,
    ...contributeSubject,
    isSubmitDisabled,
    isSuccessInfoBarVisible,
    successInfoBarMessage,
    successInfoBarTitle,
    showsEmojis: getForumEmojis(state, 'forumContribute').areVisible,
    title: props.askKooth ? __('members.forum.titles.ask'): __('members.forum.titles.startNew'),
    isAutosized: props.askKooth ? false : true,
    isExpanded: props.askKooth ? forumContributeTextEditing.isExpanded : true
  };
};

const mapDispatchToProps = (dispatch, props) => {
  const { askKooth } = props;

  return {
    onSubjectUpdate: subject => {
      dispatch(actions.forumContributeEditingUpdateSubject(subject));
    },
    onFocus: () => {
      dispatch(actions.forumContributeEditingExpand());
    },
    onTextUpdate: text => {
      dispatch(actions.forumContributeEditingUpdateText({ text }));
    },
    onSubmit: (title, text) => {
      dispatch(actions.forumThreadCreate({ title, text, askKooth }));
      dispatch(actions.forumEmojisHide('forumContribute'));
    },
    onWillUnmount: () => {
      dispatch(actions.forumEmojisHide('forumContribute'));
      dispatch(actions.forumContributeEditingReset());
    },
    onEmojisToggled: showsEmojis => {
      if(showsEmojis) {
        dispatch(actions.forumEmojisHide('forumContribute'));
      }
      else {
        dispatch(actions.forumEmojisShow('forumContribute'));
      }
    },
    onEmojiSelected: (text, emojiShortName, selectionStart) => {
      dispatch(actions.forumContributeEditingUpdateText({ text, emojiShortName, selectionStart }));
    },
    onInfoBarClose: () => {
      dispatch(actions.infoClose('success'));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Contribute);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Forum/ForumContribute/index.js
 **/